import React from "react"
import { useBrevetFunnel } from "./context/BrevetFunnelContext"
import FunnelAppDownload from "./components/FunnelAppDownload"

const BrevetAppDownloadScreen = () => {
    const { state } = useBrevetFunnel()

    return (
        <FunnelAppDownload
            firstname={state.studentFirstname}
            trackingSource="brevet_download_app"
        />
    )
}

export default BrevetAppDownloadScreen
